import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from 'rxjs/operators';
import { environment } from "src/environments/environment";
import { ApiErrorHandlerService } from "./api-error-handler.service";
import { VisaoAto } from "../model/visao-ato.model";
import { Visao } from "../model/visao.model";

@Injectable({
    providedIn: 'root'
})
export class ConsultaAppRfbService {

    private baseUrl= `${environment.apiUrl}/consulta-app-rfb/ato`;

    constructor(
        private http: HttpClient,
        private errorHandler: ApiErrorHandlerService
    ) { }

    buscarPorIdNaVisao(idAto: number, visao: Visao, tipo: string, token: string): Observable<VisaoAto> {
        const url = `${this.baseUrl}/${idAto}/visao/${visao.textoParaUrl}/${tipo}`;
        const headers = this.getHeaderComToken(token);
        return this.http.get<VisaoAto>(url, { headers }).pipe(catchError(this.errorHandler.handle()));
    }

    private getHeaderComToken(token: string) {
        if (!token) {
            token = '';
        }
        return new HttpHeaders({
            'token': token
        });
    }

    getUrlAnexoAto(idAto: number, idAnexo: number, tipoComToken: string): string {
        return `${this.baseUrl}/${idAto}/anexo/${idAnexo}/${tipoComToken}`;
    }
}